import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Select } from "@components";
import { Toggle } from "shared/components/Toggle";

export default class EyeMobileDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      active: false,
      environment: "PRODUCTION",
      pointId: null,
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "external_credentials"
    );
    const configs = externalCredentials.eyemobile || {};

    if (Object.keys(configs).length > 0) {
      this.setState({
        active: configs?.active || false,
        environment: configs?.environment || "SANDBOX",
        pointId: configs?.pointId,
      });
    }

    this.setState({
      loadingPage: false,
    });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { active, environment, pointId } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const externalCredentials =
        await EnvironmentsAPI.getConfigurationsByAlias(
          environmentId,
          "external_credentials"
        );
      const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
        environmentId,
        "external_credentials",
        {
          ...externalCredentials,
          eyemobile: {
            active,
            environment,
            pointId,
          },
        }
      );

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${
            updateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, loadingPage, active, environment, pointId } = this.state;
    const { visible, onClose } = this.props;

    const isValid = environment && pointId;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"EyeMobile"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <div className={styles.toggle}>
              <div className="d-flex justify-end w-100">
                <Toggle
                  active={active}
                  onChange={(active) => this.setState({ active })}
                />
              </div>
            </div>

            <Select
              design="two"
              label="Ambiente"
              onChange={(e) => this.setState({ environment: e.target.value })}
              className="mb-20"
              value={environment}
              options={[
                {
                  label: "Produção",
                  value: "PRODUCTION",
                  selected: environment === "PRODUCTION",
                },
                {
                  label: "Homologação",
                  value: "SANDBOX",
                  selected: environment === "SANDBOX",
                },
              ]}
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="Código da loja"
              value={pointId}
              onChange={(e) => this.setState({ pointId: e.target.value })}
            />

          </div>
        )}
      </Drawer>
    );
  }
}
